import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import Response from './Response';
import FollowUp from './FollowUp';

const Controls = (props) => {
    const { locale, mission, ModuleRP, buildings, vehicleModels, players } = props;

    const [menu, setMenu] = useState('response');

    useEffect(() => {

    }, [menu, players]);

    return (
        <div className='col-8'>
            <div>
                <div>
                    <button
                        type='button'
                        className={`btn btn-sm ${menu === 'response' ? 'btn-dark' : 'btn-secondary'} pl-4 pr-4 m-1`}
                        onClick={() => setMenu('response')}
                    >
                        {locales[locale].sgo.response}
                    </button>
                    <button
                        type='button'
                        className={`btn btn-sm ${menu === 'followUp' ? 'btn-dark' : 'btn-secondary'} pl-4 pr-4 m-1`}
                        onClick={() => setMenu('followUp')}
                    >
                        {locales[locale].sgo.followUp}
                    </button>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        {
                            menu === 'response' ? (
                                <Response
                                    locale={locale}
                                    mission={mission}
                                    ModuleRP={ModuleRP}
                                    buildings={buildings}
                                    vehicleModels={vehicleModels}
                                    players={players}
                                />
                            ) : menu === 'followUp' ? (
                                <FollowUp locale={locale} mission={mission} ModuleRP={ModuleRP} />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Controls;
